module.exports = __webpack_public_path__ + "static/media/TimeTrain_Mirrors.9de3a7f7.png";